const EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function stripPhoneDigits(phone) {
  const digits = (phone || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return digits;
}

export function formatPhoneDisplay(phone) {
  const digits = stripPhoneDigits(phone);
  if (digits.length !== 10) return phone;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function validateDisplayName(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return { valid: false, error: 'Business name is required' };
  if (trimmed.length < 2) return { valid: false, error: 'Enter at least 2 characters' };
  if (trimmed.length > 100) return { valid: false, error: 'Must be 100 characters or fewer' };
  if (!/[a-zA-Z]/.test(trimmed)) return { valid: false, error: 'Include at least one letter' };
  if (!/^[\w\s&'.,"()-]+$/u.test(trimmed)) {
    return { valid: false, error: 'Contains invalid characters' };
  }
  return { valid: true, value: trimmed };
}

export function validateBusinessName(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return { valid: true, value: '' };
  if (trimmed.length < 2) return { valid: false, error: 'Enter at least 2 characters' };
  if (trimmed.length > 150) return { valid: false, error: 'Must be 150 characters or fewer' };
  if (!/[a-zA-Z]/.test(trimmed)) return { valid: false, error: 'Include at least one letter' };
  if (!/^[\w\s&'.,"()-]+$/u.test(trimmed)) {
    return { valid: false, error: 'Contains invalid characters' };
  }
  return { valid: true, value: trimmed };
}

export function validatePhone(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return { valid: false, error: 'Phone number is required' };
  const digits = stripPhoneDigits(trimmed);
  if (digits.length !== 10) {
    return { valid: false, error: 'Enter a valid 10-digit US phone number' };
  }
  if (digits[0] === '0' || digits[0] === '1') {
    return { valid: false, error: 'Enter a valid US area code' };
  }
  return { valid: true, value: formatPhoneDisplay(trimmed), digits };
}

export function validateEmail(value) {
  const trimmed = (value || '').trim().toLowerCase();
  if (!trimmed) return { valid: false, error: 'Email is required' };
  if (trimmed.length > 255) return { valid: false, error: 'Email is too long' };
  if (/\s/.test(trimmed)) return { valid: false, error: 'Email cannot contain spaces' };
  if (!EMAIL_RE.test(trimmed)) return { valid: false, error: 'Enter a valid email address' };
  return { valid: true, value: trimmed };
}

export function validateBusinessStep(form) {
  const display = validateDisplayName(form.display_name);
  const business = validateBusinessName(form.business_name);
  return {
    valid: display.valid && business.valid,
    fields: {
      display_name: display,
      business_name: business,
    },
  };
}

export function validateContactStep(form) {
  const phone = validatePhone(form.phone);
  const email = validateEmail(form.email);
  return {
    valid: phone.valid && email.valid,
    fields: {
      phone,
      email,
    },
  };
}
